export default __webpack_public_path__ + "static/agua-fresca-desktop-a3b7459f458b080a7548345f572505f5.png";